import { sortByLabel, sortByOrder } from '@/utils';

export const documentTypesState = (state) => ({
  ...state.documentTypes,
  list: state.documentTypes.list
    .sort(sortByLabel)
});
export const documentTypesExternalsState = (state) => ({
  ...state.documentTypesExternals,
  list: state.documentTypesExternals.list
    .sort(sortByLabel)
});

export const documentProcessState = (state) => ({
  ...state.documentProcess,
  list: state.documentProcess.list
    .sort(sortByLabel)
});

export const documentSubProcessState = (state) => ({
  ...state.documentSubProcess,
  list: state.documentSubProcess.list
    .sort(sortByLabel)
});

export const documentsState = (state) => ({
  ...state.documents,
  list: state.documents.list
    .sort(sortByLabel)
});

export const allDocumentsState = (state) => ({
  ...state.allDocuments,
  list: state.allDocuments.list
    .sort(sortByLabel)
});

export const institutionTypesState = (state) => ({
  ...state.institutionTypes,
  list: state.institutionTypes.list
    .sort(sortByLabel)
});

export const institutionsState = (state) => ({
  ...state.institutions,
  list: state.institutions.list
    .sort(sortByLabel)
});

export const subjectTypesState = (state) => ({
  ...state.subjectTypes,
  list: state.subjectTypes.list
    .sort(sortByLabel)
});
export const subjectTypesStatePublic = (state) => {
  const list = [...state.subjectTypes.list]
    .concat([{
      id: '11',
      value: 'direcciones',
      label: 'Direcciones'
    },
    {
      id: '100',
      value: 'gerencias',
      label: 'Gerencias'
    }])
    .map((subject) => {
      if (subject.value === 'usuarios') {
        const typeSubject = subject;
        return {
          ...typeSubject,
          label: 'Usuarios'
        };
      }
      return subject;
    });
  return {
    ...state.subjectTypes,
    list: list
      .sort(sortByLabel)
  };
};

export const subjectsState = (state) => ({
  ...state.subjects,
  list: state.subjects.list
    .sort(sortByLabel)
});

export const institutionsDocDigitalState = (state) => ({
  ...state.institutionsDocDigital,
  list: state.institutionsDocDigital.list
    .sort(sortByLabel)
});

export const usersDocDigitalState = (state) => ({
  ...state.usersDocDigital,
  list: state.usersDocDigital.list
    .sort(sortByLabel)
});

export const myDivisionsState = (state) => ({
  ...state.myDivisions,
  list: state.myDivisions.list
    .sort(sortByLabel)
});

export const companyDivisionsState = (state) => ({
  ...state.companyDivisions,
  list: state.companyDivisions.list
    .sort(sortByLabel)
});

export const aprovalsState = (state) => state.aprovals;
export const groupsState = (state) => state.groups;
export const groupUsersState = (state) => state.groupUsers;
export const activitiesState = (state) => state.activities;
export const activityStatesState = (state) => state.activityStates;
export const userGroupsState = (state) => state.userGroups;

export const usersState = (state, getters, rootState, rootGetters) => {
  const indexedBy = rootGetters['Empresas/companyId'] || 'value';
  const index = state.users[indexedBy] || {};
  return {
    value: Object.values(index)
      .sort((a, b) => a.label.localeCompare(b.label)),
    loading: state.users.loading
  };
};

export const profilesState = (state, getters, rootState, rootGetters) => {
  const indexedBy = rootGetters['Empresas/companyId'] || 'value';
  const index = state.profiles[indexedBy] || {};
  return {
    value: Object.values(index)
      .sort((a, b) => a.label.localeCompare(b.label)),
    loading: state.profiles.loading
  };
};
export const officesState = (state) => state.offices;
export const sanitaryCompaniesState = (state) => ({
  ...state.sanitaryCompanies,
  list: state.sanitaryCompanies.list
    .sort(sortByLabel)
});
export const docDigitalList = (state) => ({
  ...state.institutionsDocDigital,
  list: state.institutionsDocDigital.list
    .sort(sortByLabel)
});

export const isapresState = (state) => ({
  ...state.isapres,
  list: state.isapres.list
    .sort(sortByLabel)
});

export const afpsState = (state) => ({
  ...state.afps,
  list: state.afps.list
    .sort(sortByLabel)
});

export const banksState = (state) => ({
  ...state.banks,
  list: state.banks.list
    .sort(sortByLabel)
});

export const academicDegreeState = (state) => ({
  ...state.academicDegree,
  list: state.academicDegree.list
    .sort(sortByLabel)
});

export const nationalityState = (state) => ({
  ...state.nationality,
  list: state.nationality.list
    .sort(sortByLabel)
});

export const titleState = (state) => ({
  ...state.title,
  list: state.title.list
    .sort(sortByLabel)
});

export const subjectState = (state) => ({
  ...state.subject,
  list: state.subject.list
    .sort(sortByLabel)
});

export const careerState = (state) => ({
  ...state.career,
  list: state.career.list
    .sort(sortByLabel)
});

export const universityState = (state) => ({
  ...state.university,
  list: state.university.list
    .sort(sortByLabel)
});

export const cityState = (state) => ({
  ...state.city,
  list: state.city.list
    .sort(sortByLabel)
});

export const responsibilityCenterState = (state) => ({
  ...state.responsibilityCenter,
  list: state.responsibilityCenter.list
    .sort(sortByLabel)
});

export const paymentPeriodState = (state) => ({
  ...state.paymentPeriod,
  list: state.paymentPeriod.list
    .sort(sortByLabel)
});

export const contractPaymentPeriodState = (state) => ({
  ...state.contractPaymentPeriod,
  list: state.contractPaymentPeriod.list
    .sort(sortByLabel)
});

export const periodState = (state) => ({
  ...state.period,
  list: state.period.list
    .sort(sortByOrder)
});

export const headOfCareerState = (state) => ({
  ...state.headOfCareer,
  list: state.headOfCareer.list
    .sort(sortByLabel)
});

export const administrativeSupportState = (state) => ({
  ...state.administrativeSupport,
  list: state.administrativeSupport.list
    .sort(sortByLabel)
});

export const administrativeResponsibleState = (state) => ({
  ...state.administrativeResponsible,
  list: state.administrativeResponsible.list
    .sort(sortByLabel)
});

export const schAttachmentsSelectors = (state) => ({
  ...state.schAttachmentsSelectors,
  list: state.schAttachmentsSelectors.list
    .sort(sortByOrder)
});

export const grcAttachmentsSelectors = (state) => ({
  ...state.grcAttachmentsSelectors,
  list: state.grcAttachmentsSelectors.list
    .sort(sortByOrder)
});

export const scfAttachmentsSelectors = (state) => ({
  ...state.scfAttachmentsSelectors,
  list: state.scfAttachmentsSelectors.list
    .sort(sortByOrder)
});

export const actAttachmentsSelectors = (state) => ({
  ...state.actAttachmentsSelectors,
  list: state.actAttachmentsSelectors.list
    .sort(sortByOrder)
});
